import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TbrData } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { CartItemViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { styles } from './action-window-styles';

const ActionWindowItemIdLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { item, tbrData, isKeypadVisible, isTBRActive } = props;
  const classes = styles({});
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={isKeypadVisible ? 7 : 9} className={classes.code}>
        <span className={classes.superText}>{t('ItemView_Code')}</span>
      </Grid>
      <Grid
        item
        xs={isKeypadVisible ? 5 : 3}
        className={`${classes.textAlignRight} ${classes.code}`}
        data-testid='action-window-item-code'
      >
        {isTBRActive ? tbrData.tbrScanData : item.lineItem?.itemId?.value}
      </Grid>
    </Grid>
  );
};

interface Props {
  isKeypadVisible: boolean | undefined;
  item: CartItemViewData;
  tbrData: TbrData;
  isTBRActive: boolean;
}

export default ActionWindowItemIdLine;
